import type { TPriceField, TPricingTableRow } from "types/modelNumbers.type"

export type TSelectedCell = {
	seriesId: number
	field: TPriceField
}

export type TDraftRow = Partial<Record<TPriceField, number | null>>

export const PRICE_FIELDS: TPriceField[] = ["min_price", "avg_price", "max_price"]

export const resolveDraftField = (
	baseValue: number | undefined,
	draftRow: TDraftRow | undefined,
	field: TPriceField,
): number | undefined => {
	if (!draftRow || !Object.prototype.hasOwnProperty.call(draftRow, field)) return baseValue
	const draftValue = draftRow[field]
	return draftValue === null ? undefined : draftValue
}

export const hasRowAllPrices = (row: Pick<TPricingTableRow, TPriceField>) =>
	PRICE_FIELDS.every((field) => typeof row[field] === "number")

export const hasRowAnyPrice = (row: Pick<TPricingTableRow, TPriceField>) =>
	PRICE_FIELDS.some((field) => typeof row[field] === "number")

export const hasRowNoPrices = (row: Pick<TPricingTableRow, TPriceField>) =>
	PRICE_FIELDS.every((field) => row[field] === undefined)

export const getNextCell = (
	currentSeriesId: number,
	currentField: TPriceField,
	rows: TPricingTableRow[],
	direction: "forward" | "backward",
): TSelectedCell | null => {
	const rowIndex = rows.findIndex((row) => row.series_id === currentSeriesId)
	const fieldIndex = PRICE_FIELDS.indexOf(currentField)

	if (direction === "forward") {
		if (fieldIndex + 1 < PRICE_FIELDS.length) {
			return { seriesId: currentSeriesId, field: PRICE_FIELDS[fieldIndex + 1] }
		}
		if (rowIndex + 1 < rows.length) {
			return { seriesId: rows[rowIndex + 1].series_id, field: PRICE_FIELDS[0] }
		}
		return null
	}

	if (fieldIndex - 1 >= 0) {
		return { seriesId: currentSeriesId, field: PRICE_FIELDS[fieldIndex - 1] }
	}
	if (rowIndex - 1 >= 0) {
		return { seriesId: rows[rowIndex - 1].series_id, field: PRICE_FIELDS[PRICE_FIELDS.length - 1] }
	}
	return null
}
